import Button from "components/Buttons/Button";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ScrollTo = ({ text, buttonBg, buttonColor, to }) => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
  return (
    <div className="my-5">
      <Link
        to={to}
      >
        <Button text={text} color={buttonColor} bgColor={buttonBg}/>
      </Link>
    </div>
  );
};

export default ScrollTo;
